/**
 * @namespace TeaserClickInternalSearch
 * @aka PIANO.TeaserClickInternalSearch
 */
PIANO.TeaserClickInternalSearch = function (window, document) {

  var SOPHORA_URL_PATTERN = /(.+(?=\/)\/)([^~]+)(?:~([^_]+)?(?:_(.+))?)?(\..+)/;

  /**
   *
   * @param {Element} elementTarget
   */
  var trackTeaserClick = function (elementTarget) {
    if (!PIANO.Utils.isEnabled()) {
      return;
    }

    var elementTeaser = elementTarget.closest('.teaser');
    if (null === elementTeaser) {
      return;
    }

    // TODO
    var data = PIANO.InternalSearch.getSearchData();

    var searchParams = new URLSearchParams(window.location.search);

    data.ise_sort = searchParams.get('swx_sort') || 'relevance';

    // determine position of clicked search result across all results
    // (including restricted and global search results)
    data.ise_click_rank = (function () {
      var searchResults = document.querySelectorAll('.suchseite .row .teaser');
      for (var i = 0; i < searchResults.length; i++) {
        if (searchResults[i] === elementTeaser) {
          return i + 1;
        }
      }
      return null;
    })();

// if clicked result is in restricted list set ise_result_list_click to restriction param value
    // otherwise to '/'
    data.ise_result_list_click = (function () {
      if (data.ise_page_restriction !== undefined) {
        var clickedElementInRestrictionList = Array.from(document.querySelector('.suchseite').querySelectorAll('.row .teaser')).includes(elementTeaser);
        if (clickedElementInRestrictionList) {
          return searchParams.get('swx_restriction');
        }
      }
      return '/';
    })();

// set ise_result_content_id to sophora id, if it can be parsed from target URL, otherwise set it to URL
    data.ise_result_content_id = (function (url)  {
      var m = url.match(SOPHORA_URL_PATTERN);
      return m ? m[2] : url;
    })(elementTeaser.querySelector('a').getAttribute('href'));

    // console.debug('Tracking Piano InternalSearchResult Click', data);

    _paq.push(['sendEvent', 'internal_search_result.click', data]);
  }

  // Listen to all clicks on the document
  document.addEventListener('click', function (event) {
    if (!PIANO.Utils.isEnabled() || !PIANO.InternalSearch.isSearchPage()) {
      return;
    }

    // If the clicked element is not a search result, bail
    if (!event.target.closest('.suchseite') || !event.target.closest('.teaser')) {
      return void 0;
    }

    // Otherwise, run your code...
    // console.debug('Tracking Piano TeaserClickInternalSearch: `.teaser` click detected', event.target);

    trackTeaserClick(event.target)
  }, false);

  /**
   * --------------------------------------------------------------------------
   * Public Pageview Api
   * --------------------------------------------------------------------------
   */
  return {};

}(window, document);
